import { gql } from "@apollo/client";

export const GET_ALL_PURCHASE_ORDERS_WITH_FULL_DETAIL = gql`
    query {
        allEquipmentPurchaseOrders {
            id
            number
            vendorName
            orderDate
            totalCents
            status
            job {
                name
                customerName
            }
            createdBy {
                id
            }
            lastUpdatedBy {
                id
            }
            orderItems {
                id
            }
            datetimeCreated
        }
}
`


export const GET_PURCHASE_ORDER_BY_ID_WITH_FULL_DETAIL = gql`
    query purchaseOrder($id: Int!) {
        purchaseOrder(id: $id) {
            id

            number
            vendorName
            orderDate
            totalCents

            createdBy {
                id
            }
            lastUpdatedBy {
                id
            }
        }
    }
`

export const GET_PURCHASE_ORDER_BY_ID_FOR_EDIT_FORM = gql`
    query equipmentPurchaseOrder($id: Int!) {
        equipmentPurchaseOrder(id: $id) {
            id
            number
            vendorName
            orderDate
            totalCents
            job {
                id
            }
            orderItems {
                id
                quantity
                itemCostCents
                equipment {
                    id
                    name
                    category {
                        id
                        name
                    }
                    sku
                }
            }
        }
    }
`

// Equipment Purchase Orders by Status
export const GET_EQUIPMENT_PURCHASE_ORDERS_BY_STATUS = gql`
    query equipmentPurchaseOrdersByStatus($status: String!) {
        equipmentPurchaseOrdersByStatus(status: $status) {
            id
            number
            vendorName
            totalCents
            orderItems {
                id
            }
        }
    }
`

// Equipment Purchase Order - Info
export const GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_INFO = gql`
    query equipmentPurchaseOrder($id: Int!) {
        equipmentPurchaseOrder(id: $id) {
            vendorName
            orderDate
            totalCents
            status
            dateReceived
        }
    }
`

// Equipment Purchase Order - Header
export const GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_NUMBER_AND_STATUS = gql`
    query equipmentPurchaseOrder($id: Int!) {
        equipmentPurchaseOrder(id: $id) {
            number
            status
        }
    }
`

export const GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_ITEMS = gql`
    query equipmentPurchaseOrder($id: Int!) {
        equipmentPurchaseOrder(id: $id) {

            orderItems {
                id
                equipment {
                    name
                    sku
                    description
                }

                quantity
                quantityReceived
            }
            

        }
    }
`

export const GET_EQUIPMENT_PURCHASE_ORDER_ITEMS_FOR_RECEIVING_FORM = gql`
    query equipmentPurchaseOrder($id: Int!) {
        equipmentPurchaseOrder(id: $id) {
            id
            number
            vendorName
            orderItems {
                id
                equipment {
                    id
                    name
                    sku
                    description
                }

                quantity
                quantityReceived
            }
        }
    }
`

export const GET_ALL_PURCHASE_ORDERS_FOR_SELECT_FIELD = gql`
    query {
        allEquipmentPurchaseOrders {
            id
            number
            vendorName
        }
    }
`

export const GET_ALL_OUTSTANDING_PURCHASE_ORDERS_FOR_SELECT_FIELD = gql`
    query equipmentPurchaseOrdersByStatus($status: String!) {
        equipmentPurchaseOrdersByStatus(status: $status) {
            id
            number
            vendorName
        }
    }
`